module.exports = __webpack_public_path__ + "static/img/ddky.99fe7588.png";